import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { InputMask } from "@react-input/mask";
import "./style.css";

const OrganizationDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);

	const [organisationName, setOrganisationName] = useState("");
	const [organisationMail, setOrganisationMail] = useState("");
	const [organisationPhone, setOrganisationPhone] = useState("");
	const [organisationAuthorizedPerson, setOrganisationAuthorizedPerson] = useState([""]);
	const [organisationFloors, setOrganisationFloors] = useState("");
	const [organisationRooms, setOrganisationRooms] = useState("");
	const [organisationBilling, setOrganisationBilling] = useState("");
	const [organisationAuthorizedPersonActive, setOrganisationAuthorizedPersonActive] = useState("Aktif");
	const [organisationActive, setOrganisationActive] = useState("Aktif");
	const [organisationBasements, setOrganisationBasements] = useState("");

	const getOrganization = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisation/${id}`);
			if (response.ok) {
				const orgData = await response.json();
				setOrganisationName(orgData.organisationName || "");
				setOrganisationMail(orgData.organisationMail || "");
				setOrganisationPhone(orgData.organisationPhone || "");
				setOrganisationAuthorizedPerson(
					orgData.organisationAuthorizedPerson && orgData.organisationAuthorizedPerson.length > 0
						? orgData.organisationAuthorizedPerson
						: [""]
				);
				setOrganisationFloors(orgData.organisationFloors || "");
				setOrganisationRooms(orgData.organisationRooms || "");
				setOrganisationBilling(orgData.organisationBilling || "");
				setOrganisationAuthorizedPersonActive(orgData.organisationAuthorizedPersonActive || "Aktif");
				setOrganisationActive(orgData.organisationActive || "Aktif");
				setOrganisationBasements(orgData.organisationBasements || "");
			} else {
				alert("Kurum bulunamadı");
				//navigate("/organizations");
			}
		} catch (error) {
			console.error("Kurum verileri getirilirken bir hata oluştu:", error);
			alert("Kurum verileri yüklenirken bir hata oluştu");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (id) {
			getOrganization();
		}
	}, [id]);

	const handleUpdate = async (e) => {
		e.preventDefault();

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			const response = await fetch(
				"https://app.vivasmartcare.com/api/organisation-update",
				{
					method: "PUT",
					body: JSON.stringify({
						id,
						organisationName,
						organisationMail,
						organisationPhone,
						organisationAuthorizedPerson,
						organisationFloors,
						organisationRooms,
						organisationBilling,
						organisationAuthorizedPersonActive,
						organisationActive,
						organisationBasements,
					}),
					headers: { "Content-Type": "application/json" },
				}
			);

			if (response.ok) {
				alert("Kurum Güncellendi");
				navigate("/organizations");
			} else {
				alert("Kurum güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			alert("Kurum güncellenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	if (loading) {
		return (
			<Layout>
				<div
					className="user-modal-inputs"
					style={{ textAlign: "center", padding: "50px" }}
				>
					<Spinner animation="border" variant="primary" />
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className="user-modal-inputs">
				<Form onSubmit={handleUpdate}>
					<Form.Group>
						<label className="mb-2">Kurum Adı:</label>
						<Form.Control
							type="text"
							placeholder="Kurum Adı Giriniz"
							value={organisationName}
							required
							onChange={(e) => setOrganisationName(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum E-posta:</label>
						<Form.Control
							type="email"
							placeholder="E-posta Adresi Giriniz"
							value={organisationMail}
							onChange={(e) => setOrganisationMail(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum Telefon:</label>
						<InputMask
							mask="+90__________"
							replacement={{ _: /\d/ }}
							value={organisationPhone}
							showMask
							onChange={(e) => setOrganisationPhone(e.target.value)}
							className="form-control"
							placeholder="Telefon No Giriniz"
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Yetkili Kişi:</label>
						{organisationAuthorizedPerson.map((person, index) => (
							<div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
								<Form.Control
									type="text"
									placeholder="Yetkili Kişi Adı Giriniz"
									value={person}
									onChange={(e) => {
										const newPersons = [...organisationAuthorizedPerson];
										newPersons[index] = e.target.value;
										setOrganisationAuthorizedPerson(newPersons);
									}}
									style={{ flex: 1 }}
								/>
								{organisationAuthorizedPerson.length > 1 && (
									<Button
										variant="danger"
										size="sm"
										type="button"
										onClick={() => {
											const newPersons = organisationAuthorizedPerson.filter((_, i) => i !== index);
											setOrganisationAuthorizedPerson(newPersons);
										}}
									>
										Sil
									</Button>
								)}
							</div>
						))}
						<Button
							variant="outline-secondary"
							size="sm"
							type="button"
							onClick={() => setOrganisationAuthorizedPerson([...organisationAuthorizedPerson, ""])}
							style={{ marginTop: "10px" }}
						>
							+ Yetkili Kişi Ekle
						</Button>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kat Sayısı:</label>
						<Form.Control
							type="number"
							placeholder="Kat Sayısı Giriniz"
							value={organisationFloors}
							required
							onChange={(e) => setOrganisationFloors(e.target.value)}
							min="1"
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Oda Sayısı:</label>
						<Form.Control
							type="number"
							placeholder="Oda Sayısı Giriniz"
							value={organisationRooms}
							required
							onChange={(e) => setOrganisationRooms(e.target.value)}
							min="1"
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Bodrum Katı:</label>
						<Form.Control
							type="number"
							placeholder="Bodrum Katı Sayısı Giriniz"
							value={organisationBasements}
							onChange={(e) => setOrganisationBasements(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Faturalama:</label>
						<Form.Control
							type="text"
							placeholder="Faturalama Bilgisi Giriniz"
							value={organisationBilling}
							onChange={(e) => setOrganisationBilling(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Yetkili Kişi Durumu:</label>
						<Form.Select
							value={organisationAuthorizedPersonActive}
							onChange={(e) => setOrganisationAuthorizedPersonActive(e.target.value)}
						>
							<option value="Aktif">Aktif</option>
							<option value="Pasif">Pasif</option>
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum Durumu:</label>
						<Form.Select
							value={organisationActive}
							onChange={(e) => setOrganisationActive(e.target.value)}
						>
							<option value="Aktif">Aktif</option>
							<option value="Pasif">Pasif</option>
						</Form.Select>
					</Form.Group>
					<div className="button-wrapper">
						<Button
							variant="secondary"
							type="button"
							onClick={() => navigate("/organizations")}
						>
							İptal
						</Button>
						<Button variant="primary" type="submit" disabled={btnDisabled}>
							{showSpinner ? (
								<>
									<Spinner
										animation="border"
										size="sm"
										style={{ marginRight: "8px" }}
									/>
									Güncelleniyor...
								</>
							) : (
								"Güncelle"
							)}
						</Button>
					</div>
				</Form>
			</div>
		</Layout>
	);
};

export default OrganizationDetail;
